import i18n from "@/shared/i18n/i18n";
import { notifications } from "@mantine/notifications";

function translate(key: string, params?: Record<string, unknown>): string {
  return params ? i18n.t(key, params) : i18n.t(key);
}

export const notify = {
  success: (key: string, params?: Record<string, unknown>): void => {
    notifications.show({ color: "green", message: translate(key, params) });
  },
  error: (key: string, params?: Record<string, unknown>): void => {
    notifications.show({ color: "red", message: translate(key, params), autoClose: 6000 });
  },
  info: (key: string, params?: Record<string, unknown>): void => {
    notifications.show({ color: "blue", message: translate(key, params) });
  },
};
